import {createSlice, type PayloadAction} from '@reduxjs/toolkit';

import {type RootState} from 'stores/redux_store';

const initialState = {
    text: '',
    enable: false,
    version: 0,
    bannerColor: '',
    textColor: '',
    allowDismiss: false,
};

export type AnnouncementBannerState = typeof initialState;

export const announcementBannerSlice = createSlice({
    name: 'announcementBannerSlice',
    initialState,
    reducers: {
        updateAnnouncementBanner(_, action: PayloadAction<AnnouncementBannerState>) {
            return action.payload;
        },
    },
});

export const updateAnnouncementBanner = announcementBannerSlice.actions.updateAnnouncementBanner;

export const getAnnouncementBannerFromState = (state: RootState) => state.announcementBannerSlice;
